import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { Company } from 'src/app/models/Company'
import { Region } from 'src/app/models/Region'
import { CompanyService } from 'src/app/services/company.service'
import { NotificationService } from 'src/app/services/notification.service'
import { RegionsService } from 'src/app/services/regions.service'

@Component({
	selector: 'app-region',
	templateUrl: './region.component.html'
})
export class RegionComponent implements OnInit {

	@Output() public close: EventEmitter<any> = new EventEmitter()
	@Output() public getRegions: EventEmitter<any> = new EventEmitter()

		@Input() public region: Region
		@Input() public allRegions: Array<Region> = []

		public companyId: string = localStorage.getItem('companyId')
		public company: Company = new Company()

		public myMap: google.maps.Map
		public positionMap: google.maps.LatLng
		public polygonsDelimitAllRegions: Array<google.maps.Polygon> = []
		public infoWindow = new google.maps.InfoWindow()
		public polygonDelimitRegion: google.maps.Polygon = new google.maps.Polygon({
				strokeOpacity: 0.6,
				strokeWeight: 2,
				fillOpacity: 0.5
		})
		public createPolygonTool = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.POLYGON,
				drawingControl: true,
				drawingControlOptions: {
						position: google.maps.ControlPosition.TOP_CENTER,
						drawingModes: [
								google.maps.drawing.OverlayType.POLYGON
						]
				},
				polygonOptions: {
						strokeOpacity: 0.6,
						strokeWeight: 2,
						fillOpacity: 0.5
				}
		})

		public enableEditOrCreate: boolean = false
		public viewAllRegionsInMap: boolean = true
	public ViewValidation: ViewValidation = new ViewValidation()

		constructor(
			public readonly notificationService: NotificationService,
			private readonly regionsService: RegionsService,
		  private readonly companyService: CompanyService
		) { }

		public async ngOnInit(): Promise<void> {
				const novaRegion = { ...this.region }
				this.region = novaRegion

				this.region.companyId = this.companyId

				if (!this.region.color) {
						this.region.color = '#a9a9a9'
				}

				await this.fetchCompany()
				await this.setPositionMap()
				await this.initMap()

				this.insertClearButtonInGoogleMaps()

				if (this.allRegions.length > 0) {
						this.insertShowRegionsButtonInGooleMaps()
						this.createAllRegions()
						this.showAllRegionsInMap()
				}

				const regionHasPolygonDefined: boolean = Boolean(
						this.region.coordinates && this.region.coordinates.length >= 3
				)

				if (regionHasPolygonDefined) {
						this.insertPolygonInMap()
				} else {
						this.insertPolygonToolInMap()
				}
		}

		public async fetchCompany(): Promise<void> {
		try {
			const response: Company = await this.companyService
				.detailCompany(this.companyId)
				.toPromise()
			this.company = response

		} catch (error) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
					}
	}

		public async setPositionMap() {

				if (this.region.coordinates && this.region.coordinates.length !== 0) {
						this.positionMap = this.region.coordinates[0]

						return
				}

				const geocoder: any = new google.maps.Geocoder()

				await geocoder.geocode({ address: this.company.address.street }, async (results, status) => {
			if (status === google.maps.GeocoderStatus.OK) {
								this.positionMap = new google.maps.LatLng(
										Number(results[0].geometry.location.lat()),
										Number(results[0].geometry.location.lng())
								)
			} else {
								this.notificationService.notify('Erro ao iniciar o mapa', 400)
						}
		})
		}

		public async initMap(): Promise<void> {
				const mapView = document.getElementById('map-regions')

		  const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 14,
			center: this.positionMap,
			gestureHandling: 'cooperative'
		})

		  map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		})

				const handlefunction = (polygon: google.maps.Polygon) => {
						this.polygonDelimitRegion = polygon

						const coordinates: Array<google.maps.LatLng> =
								polygon.getPath().getArray().map(coordinates => {
										return coordinates
								} )

			   this.region.coordinates = coordinates
						this.insertPolygonInMap()
						this.removePolygonToolFromMap()
						this.enableOrDesableBtnClear(false)
						this.setEnableSalveOrCreateButton()
		}

				google.maps.event.addListener(this.createPolygonTool, 'polygoncomplete', function(polygon: google.maps.Polygon) {
						handlefunction(polygon)
				})

				map.addListener('click', () => {
						this.infoWindow.close()
				})

		  this.myMap = map
		}

		public insertClearButtonInGoogleMaps() {
				const iconBase: string = 'assets/images/icon/clear-icon.svg'
		  const svgIcon = document.createElement('img')
		  svgIcon.setAttribute('src', iconBase)

		  const button = document.createElement('button')

				const handleClickButton = () => {
			this.clearCoordinates()
		}

		  button.setAttribute('class', 'btn-google-maps regions-button')
				button.setAttribute('id', 'btn-clear-coordinates-region')
				button.disabled = !Boolean(
						this.region.coordinates && this.region.coordinates.length >= 3
				)
		  button.appendChild(svgIcon)

		  button.addEventListener('click', () => {
			handleClickButton()
		})

		  this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
		}

		public insertShowRegionsButtonInGooleMaps() {
				const iconBase: string = 'assets/images/icon/hide-icon.svg'
		  const svgIcon = document.createElement('img')
				svgIcon.setAttribute('id', 'img-show-all-regions')
		  svgIcon.setAttribute('src', iconBase)

		  const button = document.createElement('button')

				const handleClickButton = () => {
						this.viewAllRegionsInMap = !this.viewAllRegionsInMap
			   this.switchShowHideRegionsInMap()
						this.updateImageButtonShowHideRegions()
		}

		  button.setAttribute('class', 'btn-google-maps regions-button')
		  button.appendChild(svgIcon)

		  button.addEventListener('click', () => {
			handleClickButton()
		})

		  this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
		}

		public createAllRegions() {
				this.allRegions.forEach(region => {
						if (region.id != this.region.id) {
								const polygon = new google.maps.Polygon({
										strokeOpacity: 0.6,
										strokeWeight: 2,
										fillColor: region.color,
										fillOpacity: 0.5,
										paths: region.coordinates
								})

								polygon.addListener('click', event => {
										const clickLatLng = event.latLng

										if (!this.infoWindow) {
												this.infoWindow = new google.maps.InfoWindow()
										}

										this.infoWindow.setContent(region.name)
										this.infoWindow.setPosition(clickLatLng)
										this.infoWindow.open(this.myMap)
								})

								this.polygonsDelimitAllRegions.push(polygon)
						}
				})
		}

		public insertPolygonInMap() {
				this.polygonDelimitRegion.setOptions({
						fillColor: this.region.color
				})

				this.polygonDelimitRegion.addListener('click', event => {
						const clickLatLng = event.latLng

						this.infoWindow.setContent(this.region.name)

						this.infoWindow.setPosition(clickLatLng)
						this.infoWindow.open(this.myMap)
				})

				this.polygonDelimitRegion.setPath(this.region.coordinates)

				this.polygonDelimitRegion.setMap(this.myMap)
		}

		public removePolygonFromMap() {
				if (this.polygonDelimitRegion) {
						this.polygonDelimitRegion.setMap(null)
				}
		}

		public insertPolygonToolInMap() {
				this.createPolygonTool.setMap(this.myMap)
		}

		public removePolygonToolFromMap() {
				this.createPolygonTool.setMap(null)
		}

		public switchShowHideRegionsInMap() {
				if (this.viewAllRegionsInMap) {
						this.showAllRegionsInMap()
				} else {
						this.hideAllRegionsInMap()
				}
		}

		public showAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(this.myMap)
				})
		}

		public hideAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(null)
				})

				this.infoWindow.close()
		}

		public updateImageButtonShowHideRegions() {
				const iconBase: string =
						`assets/images/icon/${this.viewAllRegionsInMap ? 'hide-icon' : 'show-icon'}.svg`

				const imageButton: HTMLImageElement =
						document.getElementById('img-show-all-regions') as HTMLImageElement

				if (imageButton) {
						imageButton.setAttribute('src', iconBase)
				}
		}

		public enableOrDesableBtnClear(disabled: boolean) {
				const button: HTMLButtonElement =
						document.getElementById('btn-clear-coordinates-region') as HTMLButtonElement

				button.disabled = disabled
		}

		public clearCoordinates() {
				this.region.coordinates = []
				this.removePolygonFromMap()

				this.enableOrDesableBtnClear(true)
				this.insertPolygonToolInMap()
		}

		public setEnableSalveOrCreateButton() {
				this.enableEditOrCreate = true

				this.polygonDelimitRegion.setOptions({
						fillColor: this.region.color
				})
		}

		public async updateRegion() {
				this.notificationService.initLoading()

				try {
						const response: string =
				await this.regionsService.editDemandRegion(this.region).toPromise()

						this.notificationService.notify(response, 200)
						this.notificationService.stopLoading()

						this.getRegions.emit()
						this.close.emit()
				} catch (error) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
						this.notificationService.stopLoading()
				}
		}

		public async saveRegion() {
				this.notificationService.initLoading()

				try {
						const response: string =
				await this.regionsService.createRegion(this.region).toPromise()

						this.notificationService.notify(response, 200)
						this.notificationService.stopLoading()

						this.getRegions.emit()
						this.close.emit()
				} catch (error) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
						this.notificationService.stopLoading()
				}
		}

		public closeDetails(): void {
		this.close.emit()
	}
}
